import { UIHeading4, UIText2, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { formatPrice } from '../../utils/format_helper';
import * as styles from './OneTwoTripSlide.css';

type TOneTwoTripSlideProps = {
  cityName: string;
  text: string;
  imageUrl: string;
  price: number;
  onClick(): void;
};

export const OneTwoTripSlide: React.VFC<TOneTwoTripSlideProps> = ({ cityName, imageUrl, price, text, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <img className={styles['image']} src={imageUrl} width="263" height="180" />
      <UIHeading4>{text}</UIHeading4>
      <UIText2 color="gray60_100">от {formatPrice(price, 4)} ₽/день</UIText2>
      <span className={styles['city']}>
        <UIText3>{cityName}</UIText3>
      </span>
    </div>
  );
};
